import { Component } from '@angular/core';

@Component({
  selector: 'about-carbohydrate',
  templateUrl: 'about-carbohydrate.html'
})
export class AboutCarbohydratePage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-carbohydrate/about-carbohydrate.ts